import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  // Input,
  Typography,
  Button,
  Flex,
  message, 
  Avatar
} from "antd";
import { MailOutlined, MenuOutlined, UserOutlined } from "@ant-design/icons";
import {
  // BellIcon,
  // SearchIcon,
  DashboardIcon,
  LogoutIcon,
  ContactsIcon,
  ProfileIcon,
  MyEventIcon
} from "../../../assets/CustomIcon";

import { getJwtPayload } from "../../../utils/appUtils";
import { selectProfileImage } from "../../../redux/userSlice";
import LoginNavigation from "../Menus/LoginNavigation";

// const { Search } = Input;
const { Header } = Layout;
const { Text } = Typography;

export default function SiteHeader({
  title,
  sidebarWidth = 0,
  isMobile = false,
  onToggleMobileMenu,
}) {
  const navigate = useNavigate();

  const profileImage = useSelector(selectProfileImage);

  // User payload from JWT token
  const token = localStorage.getItem('authToken');
  const userPayload = getJwtPayload(token);
  
  const HEADER_HEIGHT = 64;

  const headerStyle = {
    left: isMobile ? 0 : sidebarWidth,
    height: HEADER_HEIGHT,
    width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
  };

  // Logout handler
  const handleLogout = () => {
    // Clear auth token from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userLocation');
    
    // Show success message
    message.success('Logged out successfully!');
    
    // Redirect to root (login page)
    navigate('/login');
  };

  // Handle menu item clicks
  const handleMenuClick = ({ key }) => {
    switch (key) {
      case 'dashboard':
        navigate('/dashboard');
        break;
      case 'myProfile':
        navigate('/my-profile');
        break;
      case 'myEvents':
        navigate('/events');
        break;
      case 'myContacts':
        navigate('/contacts');
        break;
      case 'invitations':
        navigate('/invitation-rsvps');
        break;
      case 'logoutButton':
        handleLogout();
        break;
      default:
        break;
    }
  };

  const profileDropdown = [
    {
      key: "profileInfo",
      label: (
        <div>
          <div>{`${userPayload?.first_name || ""} ${userPayload?.last_name || ""}`.trim()}</div>
          <div>{userPayload?.email || ""}</div>
        </div>
      ),
      icon: (
          <span className="dropdownItemIcon">
              <Avatar
                src={profileImage || undefined}
                icon={!profileImage ? <UserOutlined /> : undefined}
              />
          </span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "dashboard",
      label: "Dashboard",
      icon: (
        <span className="dropdownItemIcon">
          <DashboardIcon />
        </span>
      ),
    },
    {
      key: "myProfile",
      label: "My Profile",
      icon: (
        <span className="dropdownItemIcon">
          <ProfileIcon />
        </span>
      ),
    },
    {
      key: "myEvents",
      label: "My Events",
      icon: (
        <span className="dropdownItemIcon">
          <MyEventIcon />
        </span>
      ),
    },
    {
      key: "myContacts",
      label: "My Contacts",
      icon: (
        <span className="dropdownItemIcon">
          <ContactsIcon />
        </span>
      ),
    },
    {
      key: "invitations",
      label: "Invitation RSVPs",
      icon: (
        <span className="dropdownItemIcon">
          <MailOutlined />
        </span>
      ),
    },
    {
      type: "divider",
    },
    {
      key: "logoutButton",
      label: "Logout",
      danger: true,
      icon: (
        <span className="dropdownItemIcon">
          <LogoutIcon />
        </span>
      ),
    },
  ];

  return (
    <Header style={headerStyle} className="pageHeader">
      <Flex align="center" justify="space-between" gap={12} style={{ flex: 1 }}>
        {/* mobile hamburger button */}
        {isMobile && (
          <Button
            icon={<MenuOutlined />}
            type="text"
            onClick={onToggleMobileMenu}
          />
        )}
        <Text ellipsis className="pageHeaderTitle">
          {title}
        </Text>

        <Flex
          align="center"
          justify="center"
          gap={12}
          className="pageHeaderRight"
        >
          {/* <Flex className="searchInput">
            <Search
              prefix={<SearchIcon />}
              placeholder="Search here..."
              className="searchInput"
            />
          </Flex> */}
          <LoginNavigation
            handleMenuClick={handleMenuClick}
            profileDropdown={profileDropdown}
          />
          {/* <Button
            icon={<SyncUsersIcon />}
            type="text"
            className="hasOnlyIocn"
          /> */}
          {/* <Badge dot>
            <Button
              icon={<BellIcon />}
              className="notiBell noStyleBtn"
              type="text"
              style={{ height: 24, width: 26 }}
            />
          </Badge> */}
        </Flex>
      </Flex>
    </Header>
  );
}

